const dropdownNodeList = document.querySelectorAll(".dropdown")

dropdownNodeList.forEach(function (dropdown: HTMLElement) {
  const list = dropdown.querySelector(".dropdown-list") as HTMLElement
  const dropdownArrow = dropdown.querySelector(".dropdown-arrow") as HTMLElement
  const listItems = dropdown.getElementsByClassName("dropdown-list-item")
  const dropdownSelectedNode = dropdown.querySelector(".dropdown-selected") as HTMLElement
  const listItemIds: Array<string> = []

  function focusNextListItem(direction: "up" | "down") {
    if (!document.activeElement) {
      return
    }
    const activeElementId = document.activeElement.id
    const currentActiveElementIndex = listItemIds.indexOf(activeElementId)
    if (direction === "down") {
      const currentActiveElementIsNotLastItem = currentActiveElementIndex < listItemIds.length - 1
      if (currentActiveElementIsNotLastItem) {
        const nextListItemId = listItemIds[currentActiveElementIndex + 1]
        ;(dropdown.querySelector(`#${nextListItemId}`) as HTMLElement).focus()
      }
    } else if (direction === "up") {
      const currentActiveElementIsNotFirstItem = currentActiveElementIndex > 0
      if (currentActiveElementIsNotFirstItem) {
        const nextListItemId = listItemIds[currentActiveElementIndex - 1]
        ;(dropdown.querySelector(`#${nextListItemId}`) as HTMLElement).focus()
      }
    }
  }

  function closeList() {
    list.classList.remove("open")
    dropdownArrow.classList.remove("expanded")
    dropdownSelectedNode.setAttribute("aria-expanded", "false")
  }

  function toggleListVisibility(e: MouseEvent | KeyboardEvent): void {
    if (e.type === "keydown") {
      const key = (e as KeyboardEvent).key
      if (key === " " || key === "Enter") {
        e.preventDefault()
        list.classList.toggle("open")
        dropdownArrow.classList.toggle("expanded")
        dropdownSelectedNode.setAttribute("aria-expanded", `${list.classList.contains("open")}`)
        dropdown.querySelector<HTMLElement>(".active-item")?.focus()
      } else if (key === "ArrowDown") {
        e.preventDefault()
        focusNextListItem("down")
      } else if (key === "ArrowUp") {
        e.preventDefault()
        focusNextListItem("up")
      }
    } else if (e.type === "click") {
      list.classList.toggle("open")
      dropdownArrow.classList.toggle("expanded")
      dropdownSelectedNode.setAttribute("aria-expanded", `${list.classList.contains("open")}`)
      dropdown.querySelector<HTMLElement>(".active-item")?.focus()
    }
  }

  function setSelectedListItem(e: Event): void {
    const target = e.target as HTMLElement
    const listItem = target.closest<HTMLElement>(".dropdown-list-item")
    const link = listItem?.querySelector<HTMLAnchorElement>(".dropdown-link")

    if (link) {
      link.click()
      return
    }

    if (dropdown.classList.contains("lang-dropdown")) {
      dropdownSelectedNode.innerHTML = ""
      const selectedTextToAppend = document.createTextNode(listItem?.innerText || "")
      dropdownSelectedNode.appendChild(selectedTextToAppend)
      dropdownSelectedNode.classList.add("placeholder")
    }
  }

  function sortList() {
    let i, switching, shouldSwitch
    switching = true
    if (listItems.length > 1) {
      while (switching) {
        switching = false
        Array.from(listItems).forEach(function (ele, i) {
          ele.setAttribute("id", "option-" + i)
        })
        for (i = 0; i < listItems.length - 1; i++) {
          shouldSwitch = false
          const currentElement = dropdown.querySelector<HTMLElement>("#option-" + i)
          const nextElement = dropdown.querySelector<HTMLElement>("#option-" + (i + 1))
          if (!currentElement || !nextElement) continue

          const currentText = currentElement.innerText.toLowerCase().replace("č", "c")
          const nextText = nextElement.innerText.toLowerCase().replace("č", "c")
          if (currentText > nextText) {
            shouldSwitch = true
            break
          }
        }
        if (shouldSwitch) {
          list.insertBefore(listItems[i + 1], listItems[i])
          switching = true
        }
      }
    }
  }

  if (dropdownSelectedNode) {
    dropdownSelectedNode.addEventListener("click", (e: MouseEvent) => toggleListVisibility(e))
    dropdownSelectedNode.addEventListener("keydown", (e: KeyboardEvent) => toggleListVisibility(e))
  }

  if (dropdown) {
    document.addEventListener("click", e => {
      if (!dropdown.contains(e.target as Node)) {
        closeList()
      }
    })
  }

  document.addEventListener("DOMContentLoaded", () => {
    sortList()
  })

  for (let i = 0; i < listItems.length; i++) {
    listItemIds.push("option-" + i)
  }

  Array.from(listItems).forEach(item => {
    item.addEventListener("click", e => {
      setSelectedListItem(e)
      closeList()
    })

    item.addEventListener("keydown", (e: KeyboardEvent) => {
      switch (e.key) {
        case "Enter":
          setSelectedListItem(e)
          closeList()
          return

        case "ArrowDown":
          focusNextListItem("down")
          return

        case "ArrowUp":
          focusNextListItem("up")
          return

        case "Escape":
          closeList()
          return

        default:
          return
      }
    })
  })
})
